// extracted by mini-css-extract-plugin
export var videoHero = "_dw-4";
export var videoHeroImage = "_dw-5";
export var videoHeroOverlay = "_dw-6";
export var videoHeroSubtitle = "_dw-8";
export var videoHeroText = "_dw-7";
export var videoLauncher = "_dw-0";
export var videoLauncherIcon = "_dw-1";
export var videoLauncherSubtitle = "_dw-3";
export var videoLauncherTitle = "_dw-2";
export var videoPlayer = "_dw-a";
export var videoPlayerWrap = "_dw-9";